export default "__VITE_ASSET__URm_3CBx__"